module.exports = __webpack_public_path__ + "img/abelica_global_logo.65a37beb.gif";